// src/components/admin/CandidatesManager.js
import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {electionApi} from '../../api/election';
import CandidateFormModal from './CandidateFormModal';
import {PencilIcon, TrashIcon} from '@heroicons/react/24/outline';

const CandidatesManager = ({auth, members}) => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingCandidate, setEditingCandidate] = useState(null);

    const loadCandidates = async () => {
        try {
            const res = await electionApi.getCandidates({auth});
            setCandidates(res.data);
        } catch (err) {
            alert('Ошибка загрузки кандидатов');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCandidates();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm('Удалить кандидата?')) return;
        try {
            await electionApi.deleteCandidate(id, {auth});
            loadCandidates();
        } catch (err) {
            alert('Ошибка удаления');
        }
    };

    const openCreateModal = () => {
        setEditingCandidate(null);
        setModalOpen(true);
    };

    const openEditModal = (candidate) => {
        setEditingCandidate(candidate);
        setModalOpen(true);
    };

    const handleModalClose = (success) => {
        setModalOpen(false);
        if (success) loadCandidates();
    };

    if (loading) return <div className="text-center py-4">Загрузка кандидатов...</div>;

    return (
        <div className="bg-white p-6 rounded-lg shadow mb-8">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl">Потенциальные женихи</h2>
                <button
                    onClick={openCreateModal}
                    className="bg-gold-accent text-white px-4 py-2 rounded hover:bg-yellow-600"
                >
                    + Добавить кандидата
                </button>
            </div>

            {candidates.length === 0 ? (
                <p className="text-gray-500 text-center py-4">Нет кандидатов. Создайте первого.</p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {candidates.map((c) => (
                        <div key={c.id} className="border rounded-lg overflow-hidden shadow hover:shadow-md transition">
                            <div className="h-40 bg-gray-100">
                                {c.photo_data ? (
                                    <img src={c.photo_data || c.photo_url || '/images/default.jpg'} alt={c.first_name} className="w-full h-full object-cover"/>
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400">Нет
                                        фото</div>
                                )}
                            </div>
                            <div className="p-4">
                                <h3 className="text-xl font-bold">{c.member?.first_name} {c.member?.last_name}</h3>
                                <p
                                    className="text-gray-600 text-sm line-clamp-2">{c.description || ''}</p>
                                <div className="flex justify-end gap-2 mt-3">
                                    <button onClick={() => openEditModal(c)} className="text-blue-600">
                                        <PencilIcon className="h-5 w-5"/>
                                    </button>
                                    <button onClick={() => handleDelete(c.id)} className="text-red-600">
                                        <TrashIcon className="h-5 w-5"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {modalOpen && (
                <CandidateFormModal
                    candidate={editingCandidate}
                    auth={auth}
                    members={members}
                    onClose={handleModalClose}
                />
            )}
        </div>
    );
};

export default CandidatesManager;